import { useContext } from "react";

import { AppContext } from "./index";

export function useAppContext() {
  return useContext(AppContext);
}
